/*============================
 =            Tabs            =
 ============================*/
$ = jQuery;
 var tabLinks = new Array();
 var contentDivs = new Array();

 function initTabs() {

    // Grab the tab links and content divs from the page
    var tabListItems = document.getElementById('tabs').childNodes;
    for (var i = 0; i < tabListItems.length; i++) {
    	if (tabListItems[i].nodeName == "LI") {
    		var tabLink = getFirstChildWithTagName(tabListItems[i], 'A');
    		var id = getHash(tabLink.getAttribute('href'));
    		tabLinks[id] = tabLink;
    		contentDivs[id] = document.getElementById(id);
    	}
    }

    // Assign onclick events to the tab links, and
    // highlight the first tab
    var i = 0;

    for (var id in tabLinks) {
    	tabLinks[id].onclick = showTab;
    	tabLinks[id].onfocus = function () {
    		this.blur();
    	};
    	if (i === 0)
    		tabLinks[id].className = 'selected';
    	i++;
    }

    // Hide all content divs except the first
    var i = 0;

    for (var id in contentDivs) {
    	if (i === 0) {
    		var selectedId = $(contentDivs[id]).attr('id');
    		showHideTab(selectedId);
    	}
    	i++;
    }
}

function showTab() {
	var selectedId = getHash(this.getAttribute('href'));

	showHideTab(selectedId);

    // Highlight the selected tab, and close all others.
    for (var id in contentDivs) {

    	if (id === selectedId) {
    		tabLinks[id].parentNode.className = 'selected';
    		contentDivs[id].className = 'tab__content selected';
    	} else {
    		tabLinks[id].parentNode.classList.remove('selected');
    		contentDivs[id].className = 'tab__content';
    		$('.toggle--tabs').removeClass('show--tabs');
 			$('#tabs').removeClass('show--tabs');
    	}
    }

    // Stop the browser following the link
    return false;
}

function showHideTab(selectedId) {
	var $selectedTab = $(contentDivs[selectedId]);
	var $tabContent = $('.tab__content');

	$tabContent.fadeOut(400, function () {
		if ($(this).attr('id') === selectedId) {
			$tabContent.css({"z-index": 0});
			setTimeout(function () {
				getContentHeight($selectedTab);
				$selectedTab.css({"z-index": 1});
				$selectedTab.addClass('selected').fadeIn();
			}, 400);
		}
	});
}

function getContentHeight(element) {
	var activeItem = element;
	var itemHeight = $(activeItem).outerHeight(true);
	$(activeItem).parent().css("height", itemHeight);
}

function getFirstChildWithTagName(element, tagName) {
	for (var i = 0; i < element.childNodes.length; i++) {
		if (element.childNodes[i].nodeName === tagName)
			return element.childNodes[i];
	}
}

function getHash(url) {
	var hashPos = url.lastIndexOf('#');
	return url.substring(hashPos + 1);
}

$(window).ready(function () {
	if ($('#tabs').length) {
		initTabs();
	}
});

$(window).resize(function () {
	$('.tab__wrapper').height($('.tab__wrapper .selected').height());
});
